import { httpClient } from '../lib/http-client';

export interface SlaConfig {
  id?: number;
  prioridade_id?: number | null;
  departamento_id?: number | null;
  horario_comercial_ativo: boolean;
  hora_inicio: string; // HH:MM:SS
  hora_fim: string; // HH:MM:SS
  dias_semana: number[]; // [1,2,3,4,5] onde 1=segunda, 7=domingo
  pausar_finais_semana: boolean;
  feriados?: string[] | null; // ["YYYY-MM-DD"]
  timezone: string;
  created_at?: string;
  updated_at?: string;
}

class SlaConfigService {
  /**
   * Lista todas as configurações de SLA
   */
  async listar(): Promise<SlaConfig[]> {
    return httpClient.get<SlaConfig[]>('/api/sla-config');
  }

  /**
   * Busca uma configuração específica
   */
  async buscar(id: number): Promise<SlaConfig> {
    return httpClient.get<SlaConfig>(`/api/sla-config/${id}`);
  }

  /**
   * Busca configuração por prioridade e/ou departamento
   */
  async buscarConfig(params?: { prioridade_id?: number; departamento_id?: number }): Promise<SlaConfig> {
    const queryParams = new URLSearchParams();
    if (params?.prioridade_id) {
      queryParams.append('prioridade_id', params.prioridade_id.toString());
    }
    if (params?.departamento_id) {
      queryParams.append('departamento_id', params.departamento_id.toString());
    }
    
    const url = `/api/sla-config/buscar${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return httpClient.get<SlaConfig>(url);
  }

  /**
   * Cria uma nova configuração de SLA
   */
  async criar(config: Omit<SlaConfig, 'id' | 'created_at' | 'updated_at'>): Promise<SlaConfig> {
    return httpClient.post<SlaConfig>('/api/sla-config', config);
  }

  /**
   * Atualiza uma configuração de SLA
   */
  async atualizar(id: number, config: Partial<SlaConfig>): Promise<SlaConfig> {
    return httpClient.put<SlaConfig>(`/api/sla-config/${id}`, config);
  }

  /**
   * Deleta uma configuração de SLA
   */
  async deletar(id: number): Promise<void> {
    await httpClient.delete(`/api/sla-config/${id}`);
  }
}

export default new SlaConfigService();

